module.exports = __webpack_public_path__ + "static/media/11.afd4cd92.jpg";